// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1piL5","assignButton":"CreateEditEquipmentSchedule_assignButton__1fp4d"};